module.exports = __webpack_public_path__ + "img/background.5648dd2e.png";